import React from 'react'
import { useTranslation } from 'react-i18next'
import AccordionContent from '../../../../../components/Accordion/AccordionContent'
import CompensationAccordion from '../../../../../components/Accordion'
import { usePayoutPopupContext } from '../context'
import { useCompensationPopupStyles } from '../styles'
import BonusEligibleRevenue from './BonusEligibleRevenue'
import PayoutLabel from '../components/PayoutLabel'
import BonusRate from './BonusRate'
import useAccordionLabel, { UseAccordionLabelProps } from '../components/AccordionLabel'
import clsx from 'clsx'

const BonusPayoutContent = () => {
  const { labelAsAccordion, smallSpacingLabel, aqua100Label, grey300Label, firstLevelLabel, leftAlignedToAccordionLg } =
    useCompensationPopupStyles()
  const { t } = useTranslation()
  const { data, updatePopoverPosition, isTotalBonusBiggerThanGuaranteed } = usePayoutPopupContext()

  const labelClasses: UseAccordionLabelProps['classNames'] = () => ({
    container: clsx(smallSpacingLabel, isTotalBonusBiggerThanGuaranteed ? aqua100Label : grey300Label),
    label: { label: firstLevelLabel, value: firstLevelLabel },
  })

  const renderBonusRevenueLabel = useAccordionLabel({
    value: data?.monthlyRevenue ?? 0,
    label: 'total_bonus_eligible_revenue',
    classNames: labelClasses,
  })

  const renderBonusRateLabel = useAccordionLabel({
    value: (data?.bonusRate.totalBonusRate ?? 0) * 100,
    label: 'total_bonus_rate',
    format: 'percentage',
    classNames: labelClasses,
  })

  if (!data) {
    return null
  }

  const labelClassName = clsx(labelAsAccordion, firstLevelLabel, leftAlignedToAccordionLg)

  return (
    <>
      <CompensationAccordion onToggleHandler={updatePopoverPosition} renderLabel={renderBonusRevenueLabel}>
        <AccordionContent>
          <BonusEligibleRevenue />
        </AccordionContent>
      </CompensationAccordion>

      <CompensationAccordion onToggleHandler={updatePopoverPosition} renderLabel={renderBonusRateLabel}>
        <AccordionContent>
          <BonusRate />
        </AccordionContent>
      </CompensationAccordion>

      <PayoutLabel
        classes={{ label: labelClassName, value: labelClassName }}
        label={t('compensation_popup_deduction_rate_label')}
        value={data.discountRate * 100}
        format="percentage"
      />
    </>
  )
}

export default BonusPayoutContent
